import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

export const recruitingJobCategoryQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});
export type RecruitingJobCategoryQueryLinkerSchema = z.infer<typeof recruitingJobCategoryQueryLinkerSchema>;

export const recruitingJobCategoryQuerySchema = z.object({
  ...recruitingJobCategoryQueryLinkerSchema.shape,
  status: statusQuerySchema,
});

export type RecruitingJobCategoryQuerySchema = z.infer<typeof recruitingJobCategoryQuerySchema>;

export const recruitingJobCategoryQueryAllSchema = paginatedResponseSchema(recruitingJobCategoryQuerySchema);
export type RecruitingJobCategoryQueryAllSchema = z.infer<typeof recruitingJobCategoryQueryAllSchema>;
